const u = up.util;
const e = up.element;
up.migrate.renamedPackage('syntax', 'script');
up.migrate.postCompile = function (elements, compiler) {
    let keepValue;
    if (keepValue = compiler.keep) {
        up.migrate.warn('The { keep: true } option for up.compiler() has been removed. Have the compiler set [up-keep] attribute instead.');
        const value = u.isString(keepValue) ? keepValue : '';
        for (let element of elements) {
            element.setAttribute('up-keep', value);
        }
    }
};
up.migrate.targetMacro = function (queryAttr, fixedResultAttrs, callback) {
    up.macro(`[${queryAttr}]`, function (link) {
        let optionalTarget;
        const resultAttrs = u.copy(fixedResultAttrs);
        if ((optionalTarget = link.getAttribute(queryAttr))) {
            resultAttrs['up-target'] = optionalTarget;
        }
        else {
            resultAttrs['up-follow'] = '';
        }
        e.setMissingAttrs(link, resultAttrs);
        link.removeAttribute(queryAttr);
        callback === null || callback === void 0 ? void 0 : callback();
    });
};
up.$compiler = function (...definitionArgs) {
    up.migrate.warn('up.$compiler() has been deprecated. Instead use up.compiler() with a callback that wraps the given native element in a jQuery collection.');
    let $fn = definitionArgs.pop();
    return up.compiler(...definitionArgs, function (element, ...fnArgs) {
        let $element = jQuery(element);
        return $fn($element, ...fnArgs);
    });
};
up.$macro = function (...definitionArgs) {
    up.migrate.warn('up.$macro() has been deprecated. Instead use up.macro() with a callback that wraps the given native element in a jQuery collection.');
    let $fn = definitionArgs.pop();
    return up.macro(...definitionArgs, function (element, ...fnArgs) {
        let $element = jQuery(element);
        return $fn($element, ...fnArgs);
    });
};
up.migrate.processHelloMeta = function (meta, response) {
    Object.defineProperty(meta, 'response', { get() {
            up.migrate.warn('Accessing meta.response from a compiler has been deprecated without replacement. Avoid fragments that compile differently for the initial page load vs. subsequent fragment updates.');
            return response;
        } });
};
let modernHello = up.hello;
let errorMessage = 'up.hello() is now async and returns a promise';
class WasElementIsPromise extends Promise {
}
up.migrate.defineThrowingProps(WasElementIsPromise.prototype, Element.prototype, errorMessage);
up.migrate.defineThrowingProps(WasElementIsPromise.prototype, Node.prototype, errorMessage);
up.migrate.defineThrowingProps(WasElementIsPromise.prototype, EventTarget.prototype, errorMessage);
up.hello = function (element, ...args) {
    let elementPromise = modernHello(element, ...args);
    return WasElementIsPromise.resolve(elementPromise);
};
